/* Baby Lilo motion engine */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.jxf-reveal:not(.jxf-reveal--bound)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-visible', 'jxf-reveal--bound'); }); return; }
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.classList.add('jxf-reveal--bound'); io.observe(el); });
  }
  function initSwipers(root) {
    if (typeof Swiper === 'undefined') return false;
    var nodes = (root || document).querySelectorAll('[data-jxf-swiper]:not(.jxf-swiper--bound)');
    nodes.forEach(function (node) {
      node.classList.add('jxf-swiper--bound');
      var cfg = {};
      try { cfg = JSON.parse(node.getAttribute('data-jxf-swiper') || '{}'); } catch (e) { cfg = {}; }
      var perView = cfg.perView || 4;
      var options = { slidesPerView: cfg.perViewMobile || 1.15, spaceBetween: 14, speed: 500, grabCursor: true, watchOverflow: true, breakpoints: { 750: { slidesPerView: cfg.perViewTablet || Math.min(perView, 2.2), spaceBetween: cfg.gap != null ? cfg.gap : 24 }, 990: { slidesPerView: perView, spaceBetween: cfg.gap != null ? cfg.gap : 24 } } };
      if (cfg.loop) options.loop = true;
      var nextEl = node.parentElement.querySelector('[data-jxf-next]');
      var prevEl = node.parentElement.querySelector('[data-jxf-prev]');
      if (nextEl && prevEl) options.navigation = { nextEl: nextEl, prevEl: prevEl };
      new Swiper(node, options);
    });
    return true;
  }
  function whenSwiperReady(root) {
    if (initSwipers(root)) return;
    var tries = 0;
    var t = setInterval(function () { tries++; if (initSwipers(root) || tries > 40) clearInterval(t); }, 100);
  }
  function initTabs(root) {
    var groups = (root || document).querySelectorAll('[data-jxf-tabs]:not(.jxf-tabs--bound)');
    groups.forEach(function (group) {
      group.classList.add('jxf-tabs--bound');
      var tabs = group.querySelectorAll('[data-jxf-tab]');
      var panels = group.querySelectorAll('[data-jxf-panel]');
      tabs.forEach(function (tab) { tab.addEventListener('click', function () { var key = tab.getAttribute('data-jxf-tab'); tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); }); panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-jxf-panel') === key); }); }); });
    });
  }
  function initStickyHeader() {
    var header = document.querySelector('[data-jxf-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  function initMobileNav() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-jxf-nav-toggle]')) { document.documentElement.classList.toggle('jxf-nav-open'); return; }
      if (e.target.closest('[data-jxf-nav-close]') || (document.documentElement.classList.contains('jxf-nav-open') && e.target.classList.contains('jxf-mobile-nav__overlay'))) { document.documentElement.classList.remove('jxf-nav-open'); }
    });
  }
  function boot(root) { initReveal(root); whenSwiperReady(root); initTabs(root); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { boot(document); initStickyHeader(); initMobileNav(); }); } else { boot(document); initStickyHeader(); initMobileNav(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); initStickyHeader(); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
